export const ActionTypes = {
  SET_PRODUCTS: "SET_PRODUCTS",
  SELECTED_PRODUCT: "SELECTED_PRODUCT",
  REMOVE_SELECTED_PRODUCT: "REMOVE_SELECTED_PRODUCT",
  FILTER_PRODUCT: "FILTER_PRODUCT",
  INCR_QUANT: "INCR_QUANT",
  DECR_QUANT: "DECR_QUANT",
  ADD_PRODUCT: "ADD_PRODUCT",
  SUBTOTAL: "SUBTOTAL",
  DELETE_PRODUCT: "DELETE_PRODUCT",
};
